import Vue from 'vue';
import axios from 'axios';
import Constants from '@/plugins/constants';
const apiClient = axios.create({
  baseURL: Constants.MAINURL,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});
var options = {
  persist: true,
};
Vue.use(options);
apiClient.interceptors.request.use(
  function (config) {
    config.headers['Content-Type'] = 'application/json';
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

const state = {
  error400: false,
  error: '',
  successFlag: false,
  token: '',
  allTriageQuestions: [],
  errorStatus: null,
  triageQuestions: null,
  triageQuestion: null,
  triageQuestionWithChiefComplaint: null,
};
const getters = {
  getApiLoad_103: (state) => {
    return state.successFlag;
  },
};
const mutations = {
  set_error400(state, error) {
    state.error400 = error;
  },
  SET_Status(state, status) {
    state.successFlag = status;
  },
  SET_Error(state, error) {
    state.error = error;
  },
  SET_errorStatus(state, error) {
    state.errorStatus = error;
  },
  SET_AllTriageQuestions(state, data) {
    state.allTriageQuestions = data;
  },
  SET_TriageQuestions(state, data) {
    state.triageQuestions = data;
  },
  SET_TriageQuestion(state, data) {
    state.triageQuestion = data;
  },
  SET_TriageQuestionWithChiefComplaint(state, data) {
    state.triageQuestionWithChiefComplaint = data;
  },
};
const actions = {
  errorTriageQuestion({ commit }, temperror) {
    var error = temperror;
    if (error) {
      if (error.response) {
        if (error.response.status) {
          if (error.response.status == 401) {
            commit('SET_errorStatus', true);
            commit('set_error400', false);
          } else if (error.response.status == 400) {
            commit('SET_errorStatus', false);
            commit('set_error400', true);
          } else {
            commit('SET_errorStatus', false);
            commit('set_error400', false);
          }
        }
        if (error.response.data) {
          commit('SET_Error', error.response.data.message);
        } else {
          commit('SET_Error', 'عدم ارتباط با سرور');
        }
      } else {
        commit('SET_errorStatus', false);
        commit('set_error400', false);
        commit('SET_Error', 'خطا در برقراری ارتباط با سرور');
      }
      commit('SET_Status', false);
    } else {
      commit('SET_Error', 'خطا امنیتی');
    }
  },
  getAllTriageQuestionsWithCheifComplaintId({ commit, dispatch, rootState }, cheifComplaintId) {
    let url = '/TriageQuestions/All?CheifComplaintId=' + cheifComplaintId;
    return apiClient
      .get(url, { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } })
      .then((response) => {
        commit('SET_AllTriageQuestions', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorTriageQuestion', error);
      });
  },
  getAllTriageQuestionsByMissionIdDispatch({ commit, dispatch, rootState }, params) {
    return apiClient
      .get('/Missions/TriageQuestions', {
        params,
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_AllTriageQuestions', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorTriageQuestion', error);
      });
  },
  getTriageQuestions({ commit, dispatch, rootState }, cheifComplaintId) {
    return apiClient
      .get('/TriageQuestions/RootByChiefComplaint?chiefComplaintId=' + cheifComplaintId, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_TriageQuestions', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorTriageQuestion', error);
      });
  },
  addTriageQuestion({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/TriageQuestions', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_TriageQuestions', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorTriageQuestion', error);
      });
  },
  addTriageQuestionRoot({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/TriageQuestions/Root', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorTriageQuestion', error);
      });
  },
  getTriageQuestion({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/TriageQuestions/ById?triageQuestionId=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_TriageQuestion', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorTriageQuestion', error);
      });
  },
  getTriageQuestionWithDetail({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/TriageQuestions/ByIdWithDetails?triageQuestionId=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_TriageQuestion', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorTriageQuestion', error);
      });
  },
  getTriageQuestionWithCheifComplaintId({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/TriageQuestions/RootByChiefComplaint?chiefComplaintId=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_TriageQuestionWithChiefComplaint', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorTriageQuestion', error);
      });
  },
  editTriageQuestion({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/TriageQuestions/Edit', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorTriageQuestion', error);
      });
  },
  deleteTriageQuestion({ commit, dispatch, rootState }, id) {
    return apiClient
      .post(
        '/TriageQuestions/Remove?triageQuestionId=' + id,
        {},
        { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } },
      )
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorTriageQuestion', error);
      });
  },
};
export default {
  mutations,
  getters,
  state,
  actions,
};
